import type { ComponentProps } from "react";

import { SvgSlot } from "@/shared/ui/common";

export const KlarnaIcon = (props: ComponentProps<typeof SvgSlot>) => (
  <SvgSlot {...props}>
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.25267 5V19.1667H4V5H7.25267ZM15.3702 5C15.3702 7.97075 14.2489 10.741 12.2429 12.8398L12.046 13.0403L16.5389 19.1667H12.5241L7.64154 12.5083L8.90167 11.5648C10.9261 10.049 12.114 7.75542 12.1862 5.24367L12.1897 5H15.3702ZM19.2292 15.625C19.6988 15.625 20.1492 15.8116 20.4813 16.1437C20.8134 16.4758 21 16.9262 21 17.3958C21 17.8655 20.8134 18.3159 20.4813 18.648C20.1492 18.9801 19.6988 19.1667 19.2292 19.1667C18.7595 19.1667 18.3091 18.9801 17.977 18.648C17.6449 18.3159 17.4583 17.8655 17.4583 17.3958C17.4583 16.9262 17.6449 16.4758 17.977 16.1437C18.3091 15.8116 18.7595 15.625 19.2292 15.625Z" />
    </svg>
  </SvgSlot>
);
